import React, { useState } from "react";
import Header from "../Sharedcomponents/Header/Header";
import contactbg from "../assets/contactbg.jpg";
import "./ContactUs.css";
import { BookSlot } from "../RegistrationForm/BookSlot";
import Footer from "../Component/Footer";
import axios from "axios";
import { postContacturl } from "../Services/BackendUrl";
import { FcOk } from "react-icons/fc";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    contactNumber: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [showSuccess, setShowSuccess] = useState(false);


  const validate = (fieldValues = formData) => {
    const newErrors = { ...errors };

    if ("name" in fieldValues) {
      newErrors.name = !fieldValues.name.trim() ? "Name is required." : "";
    }

if ("message" in fieldValues) {
  newErrors.message = !fieldValues.message.trim() ? "Message is required." : "";
}

   if ("contactNumber" in fieldValues) {
  if (!fieldValues.contactNumber.trim()) {
    newErrors.contactNumber = "Contact number is required.";
  } else if (!/^\d+$/.test(fieldValues.contactNumber)) {
    newErrors.contactNumber = "Contact number must contain only digits.";
  } else {
    newErrors.contactNumber = "";
  }
}



    if ("email" in fieldValues) {
      if (!fieldValues.email.trim()) {
        newErrors.email = "Email is required.";
      } else if (!/\S+@\S+\.\S+/.test(fieldValues.email)) {
        newErrors.email = "Email is invalid.";
      } else {
        newErrors.email = "";
      }
    }

    setErrors({ ...newErrors });
  };
  

  const handleChange = (e) => {
    const { name, value } = e.target;

    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    validate({ [name]: value });
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched({ ...touched, [name]: true });
    validate({ [name]: formData[name] });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const newErrors = {};
  if (!formData.name.trim()) newErrors.name = "Name is required.";
  if (!formData.contactNumber.trim()) newErrors.contactNumber = "Contact number is required.";
  if (!formData.email.trim()) {
    newErrors.email = "Email is required.";
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    newErrors.email = "Email is invalid.";
  }
  if (!formData.message.trim()) {
  newErrors.message = "Message is required.";
}

  setErrors(newErrors);
  setTouched({ name: true, contactNumber: true, email: true });

  const hasErrors = Object.values(newErrors).some((err) => err);
  if (hasErrors) return;

 try {
  await axios.post(postContacturl, formData);
  setShowSuccess(true); 
  setFormData({ name: "", contactNumber: "", email: "", message: "" });
  setTouched({});
  setErrors({});

  setTimeout(() => {
    setShowSuccess(false); 
  }, 3000);
} catch (error) {
  console.error("Submission failed", error);
}

};


  return (
    <div>
      <Header />

      <div
        className="w-full  bg-cover bg-center relative"
        style={{ backgroundImage: `url(${contactbg})` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-90"></div>

        <div className="relative z-10   px-4 pt-32 pb-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 w-full xl:px-20 lg:mt-20 gap-10 md:gap-12 text-white">
            <div className="space-y-8 pl-2 z-10">
              <p className="text-[32px] lg:text-[60px] xl:text-[71px] tracking-wide font-langit">
                CONTACT US<span className="text-orange-500">.</span>
              </p>

              <div className="left-orange-border space-y-6 lg:space-y-4 xl:space-y-6">
                <div className="flex flex-col gap-2 pl-5 md:pl-16 pb-4">
                  <h3 className="uppercase tracking-widest pb-4 font-extralight text-[#777777] font-league text-[16px] md:text-[20px] xl:text-[22px]">
                    Contact Us
                  </h3>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    cosmaosacademy@gmail.com
                  </p>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    +001 9923 38844
                  </p>
                </div>
                <div className="flex flex-col gap-2 pl-5  md:pl-16 pb-4">
                  <h3 className="uppercase tracking-widest pb-4 font-light text-[#777777] font-league text-[16px] md:text-[20px] xl:text-[22px]">
                    Kosmos Ruwi Branch (Shop 1)
                  </h3>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    Al Ghubrah South, Way No.
                  </p>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    4021, Muscat 133, Oman
                  </p>
                </div>
                <div className="flex flex-col gap-2 pl-5  md:pl-16 pb-4">
                  <h3 className="uppercase tracking-widest font-light pb-4 text-[#777777]  font-league text-[16px] md:text-[20px] xl:text-[22px]">
                    Kosmos Ghala Branch (Shop 2)
                  </h3>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    Al Ghubrah South, Way No.
                  </p>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    4021, Muscat 133, Oman
                  </p>
                </div>
                <div className="flex flex-col gap-2 pl-5  md:pl-16 pb-4">
                  <h3 className="uppercase tracking-widest pb-4 font-light text-[#777777] font-league text-[16px] md:text-[20px] xl:text-[22px]">
                    Kosmos Riyaz Branch (Shop 3)
                  </h3>
                  <p className="tracking-wider font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    Al Ghubrah South, Way No.
                  </p>
                  <p className="tracking-wider  font-lufga text-[14px] md:text-[18px] xl:text-[20px]">
                    4021, Muscat 133, Oman
                  </p>
                </div>
              </div>
            </div>

            <div className="relative p-4 md:p-8 ">
              <div className="corner top-left"></div>
              <div className="corner top-right"></div>
              <div className="corner bottom-left"></div>
              <div className="corner bottom-right"></div>

              <div className="bg-[#1b1b1b]   px-8  py-12  w-full">
                <p className="absolute top-0 left-[28%]  md:left-[35%] lg:left-[28%] xl:left-[30%] text-[30px] md:text-[48px] xl:text-[64px] font-light text-white text-center tracking-wider font-league mb-6">
                  ENQUIRY FORM
                </p>

              <form
                onSubmit={handleSubmit}
                className="space-y-10 "
              >
                <div className="group">
                  <label className="tracking-widest  text-[#777777] group-hover:text-[#F58220] transition-colors duration-200">
                    <p className="text-[20px] font-extralight  font-league">
                      NAME <span className="text-red-500">*</span>
                    </p>
                  </label>
                  <input
                    name="name"
                    value={formData.name}
                    onKeyPress={(e) => {if(!/^[A-Za-z\s]+$/.test(e.key)) {e.preventDefault()}}}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className=" no-autofill w-full mt-1 bg-transparent border-t-0 border-x-0 border-b-2 border-[#777777] text-white outline-none py-2 font-lufga tracking-wide group-hover:border-orange-500 transition-colors duration-200"
                  />
                  {errors.name && (
                    <p className="text-red-500 text-xs mt-1 font-spartan">{errors.name}</p>
                  )}
                </div>

                <div className="group">
                  <label className="tracking-widest text-[#777777] group-hover:text-orange-500 transition-colors duration-200">
                    <p className="text-[16px] md:text-[20px] font-light font-league">
                      CONTACT NUMBER <span className="text-red-500">*</span>
                    </p>
                  </label>
                  <input
                    name="contactNumber"
                     type="tel"
                    value={formData.contactNumber}
                    onKeyPress={(e) => {  if (!/[0-9]/.test(e.key)) { e.preventDefault()}}}
                    maxLength={10}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="no-autofill w-full mt-1 bg-transparent border-t-0 border-x-0 border-b-2 border-[#777777] text-white outline-none py-2 font-lufga  tracking-wide group-hover:border-orange-500 transition-colors duration-200"
                  />
                  {errors.contactNumber && (
                    <p className="text-red-500 text-xs mt-1 font-spartan">
                      {errors.contactNumber}
                    </p>
                  )}
                </div>

                  <div className="group">
                    <label className="tracking-widest text-[#777777] group-hover:text-orange-500 transition-colors duration-200">
                      <p className="text-[16px] md:text-[20px] font-extralight font-league">
                        E-MAIL <span className="text-red-500">*</span>
                      </p>
                    </label>
                    <input
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className="no-autofill w-full mt-1 bg-transparent border-t-0 border-x-0 border-b-2 border-[#777777] text-white outline-none py-2 font-lufga  tracking-wide group-hover:border-orange-500 transition-colors duration-200"
                    />
                    {errors.email && (
                      <p className="text-red-500 text-xs md:text-sm mt-1 font-spartan">
                        {errors.email}
                      </p>
                    )}
                  </div>

                  <div className="group">
                    <label className="tracking-wider text-[#777777] group-hover:text-orange-500 transition-colors duration-200">
                      <p className="text-[16px] md:text-[20px] font-league font-light">
                        MESSAGE <span className="text-red-500">*</span>
                      </p>
                    </label>
                    <textarea
                      name="message"
                      rows={2}
                      value={formData.message}
                      onChange={handleChange}
                      onBlur={handleBlur} 
                      className="no-autofill-bg w-full mt-1 bg-transparent border-t-0 border-x-0 border-b-2 border-[#777777] text-white outline-none py-2 font-lufga  tracking-wide group-hover:border-orange-500 transition-colors duration-200"
                    ></textarea>
                    {errors.message && (
    <p className="text-red-500 text-xs mt-1 font-spartan">{errors.message}</p>
  )}
                  </div>

                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="w-full cursor-pointer border-none bg-orange-500 text-white tracking-wider text-[24px] lg:text-[32px] py-3 mt-6 hover:bg-orange-600 transition-all font-league"
                >
                  CONFIRM TO CONTACT
                </button>
                {showSuccess && (
                          <div>
                            <div style={{backgroundColor:'#63F52066', width:'100%', padding:'20px', marginTop:'10px', display:'flex', justifyContent:'flex-start', gap:'20px', color:'white'}}>
                              <FcOk />
                              Thank you! Your Enquiry has been successfully submitted
                            </div>
                          </div>
                        )}
              </form>
            </div>
            </div>
          </div>
        </div>
      </div>
      <BookSlot />
      <Footer />
    </div>
  );
};

export default ContactUs;